<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Vehicle Types</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Vehicle Types
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Admins</h4>
                </div>

                <div class="card-body">
                    <div class="row mb-2">
                        <div class="form-group col-md-4">
                            <input type="text" v-model="searchTerm"
                                   class="form-control"
                                   placeholder="🔎 Search this table (Name, description)"
                                   @keyup="paginatedData"
                            >
                        </div>
                    </div>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allVehicleTypes"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.vehicle-types.edit', props.row.id)">{{ props.row.name }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'description'">
                                {{ props.row.description }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
                                    <a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries=""
                                    >
                                        <a :href="route('admin.vehicle-types.edit', props.row.id)"
                                           class="dropdown-item edit"><i class="feather icon-edit-2"></i>
                                            Edit
                                        </a>
                                        <a @click.prevent="deleteVehicleType(props.row.id)"
                                           class="dropdown-item edit"><i class="feather icon-trash"></i>
                                            Delete
                                        </a>
                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Admin'},
    props: ['vehicleTypesData'],
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allVehicleTypes: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Description', field: 'description'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    mounted() {
        this.allVehicleTypes = this.vehicleTypesData.data;
        this.totalRecords = this.vehicleTypesData.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.vehicle-types.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;
                let {data: {data: {vehicle_types}}} = await axios.get(url);

                this.totalRecords = vehicle_types.total;
                this.paginationOptions.perPage = vehicle_types.per_page;
                this.allVehicleTypes = vehicle_types.data
            } catch (e) {
                console.log(e);
            }
        },

        async deleteVehicleType(id) {
            try {
                let url = route('admin.vehicle-types.destroy', id);

                this.$inertia.delete(url);
                this.$inertia.get(route('admin.vehicle-types.index'));
            } catch (e) {
                console.log(e);
            }

        },
        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
    }
}
</script>
